import React from "react";

import TopBarCenter from "@/sot/primitives/TopBarCenter.jsx";

// This is the structural contract extracted from PharmacyAccount. Workspace
// accounts may supply truthful identity data and routes, but must share the
// source title/back geometry and responsive two-column account grid.
export const WORKSPACE_ACCOUNT_GRID_CLASS =
  "grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1.1fr)_320px] lg:gap-10";

export default function WorkspaceAccountContract({ title = "My account", subtitle, onBack, children }) {
  return (
    <>
      <TopBarCenter title={title} subtitle={subtitle} onBack={onBack} />
      {children}
    </>
  );
}
